import { INITIAL_OPERATORS_REQUEST, FETCH_OPERATORS_SUCCESS, FINAL_OPERATORS_REQUEST } from "../../types/maintainers/operators.type";

const initialState = {
	estates_parents: [],
	estates: [],
	categories: [],
	customers: [],
	operators: [],
	last_page: 0,
	from: 0,
	to: 0,
	isFetching: false,
};

function maintainers_operators(state = initialState, action) {
	switch (action.type) {
		case INITIAL_OPERATORS_REQUEST:
			return {
				...state,
				isFetching: true,
			};
		case FETCH_OPERATORS_SUCCESS:
			return {
				...state,
				isFetching: false,
				customers: action.payload.customers,
				estates_parents: action.payload.estates_parents,
				estates: action.payload.estates,
				categories: action.payload.categories,
				operators: action.payload.operators,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
				quantity: action.payload.quantity,
			};
		case FINAL_OPERATORS_REQUEST:
			return {
				...state,
				isFetching: false,
			};
		default:
			return state;
	}
}

export default maintainers_operators;
